namespace $.$$ {

	$mol_style_define( $shm_dashboard_admin_users, {
		width: '100%',
		minWidth: 0,
		height: '100%',
		minHeight: 0,
		maxHeight: '100%',
		overflow: 'auto',

		Users_page: {
			flex: { basis: '34rem', grow: 0, shrink: 0 },
		},

		Dashboards: {
			flex: { basis: '48rem', grow: 1, shrink: 0 },
		},

		List_head: {
			flex: { grow: 1, shrink: 1 },
		},

		Table_head: {
			display: 'grid',
			gridTemplateColumns: 'minmax(0, 1.3fr) minmax(0, 1fr) minmax(0, .85fr) minmax(0, 1.05fr)',
			minWidth: 0,
			padding: { left: $mol_gap.block, right: $mol_gap.block },
			gap: '8px',
			color: $mol_theme.shade,
			font: {
				size: '12px',
				weight: 'bold',
			},
		},

		Row: {
			display: 'grid',
			gridTemplateColumns: 'minmax(0, 1.3fr) minmax(0, 1fr) minmax(0, .85fr) minmax(0, 1.05fr)',
			gap: '8px',
			minWidth: 0,
			justifyContent: 'stretch',
			textAlign: 'left',
			padding: {
				top: '6px',
				bottom: '6px',
			},
			border: {
				top: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
		},

		Email: {
			minWidth: 0,
			overflowWrap: 'anywhere',
		},

		Name: {
			minWidth: 0,
			overflowWrap: 'anywhere',
		},

		Created: {
			minWidth: 0,
			overflowWrap: 'anywhere',
			color: $mol_theme.shade,
		},

		Id: {
			minWidth: 0,
			overflowWrap: 'anywhere',
			color: $mol_theme.shade,
			font: {
				family: 'monospace',
				size: '12px',
			},
		},
	} )

	$mol_style_define( $shm_dashboard_admin_users_row, {
		'@': {
			shm_dashboard_admin_users_row_current: {
				true: {
					color: $mol_theme.current,
					$mol_view: {
						color: $mol_theme.current,
					},
				},
			},
		},
	} )

}
